import React, { useEffect, useRef } from "react";

// Trustindex Google Reviews widget — syncs live from CEO Travel's Google Business Profile.
// NOTE: this widget layout ("Slider I. - with header") is free for 7 days only from Trustindex.
// After that, either upgrade on trustindex.io or swap this src for a permanently-free layout.
const TRUSTINDEX_SRC =
  "https://cdn.trustindex.io/loader.js?b99cf62820622546873670c6a00";

export const Testimonial = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    // Avoid injecting the script twice if this component re-renders
    if (containerRef.current.querySelector("script[data-trustindex]")) return;

    const script = document.createElement("script");
    script.src = TRUSTINDEX_SRC;
    script.defer = true;
    script.async = true;
    script.setAttribute("data-trustindex", "true");
    containerRef.current.appendChild(script);
  }, []);

  return (
    <section
      id="testimonial"
      data-testid="testimonial-section"
      className="bg-[#FBFAF6] py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div ref={containerRef} />
      </div>
    </section>
  );
};

export default Testimonial;
